import Brand from '@/entities/Brand.js';
import Campaign from '@/entities/Campaign.js';
import Rule from '@/entities/Rule.js';
import RuleActivityLog from '@/entities/RuleActivityLog.js';
import SourceProfile from '@/entities/SourceProfile.js';
import api from '@/services/Api';

export default {
  get(id) {
    return api().get('/brand/' + id)
      .then(resp => new Brand(resp));
  },

  create(data) {
    return api().post('/brand', data)
      .then(resp => new Brand(resp));
  },

  update(id, data) {
    return api().put('/brand/' + id, data)
      .then(resp => new Brand(resp));
  },

  deactivate(id, pauseCampaigns) {
    return api().put('/brand/' + id + '/deactivate', { pause_campaigns: pauseCampaigns })
      .then(resp => ({ brand: new Brand(resp.brand), failedCampaigns: resp.failed_campaigns.map(i => new Campaign(i)) }));
  },

  activate(id, chargeExtraBrands = false) {
    return api().put('/brand/' + id + '/activate', { charge_extra_brands: chargeExtraBrands })
      .then(resp => ({ brand: new Brand(resp.brand), failedCampaigns: resp.failed_campaigns.map(i => new Campaign(i)) }));
  },

  deletePrecheck(id) {
    return api().get('/brand/' + id + '/delete-precheck')
      .then(resp => {
        const rawRules = resp.defunct_rules ?? resp.defunc_rules ?? [];
        return {
          defunc_rules: rawRules.map(item => new Rule(item)),
        };
      });
  },

  delete(id) {
    return api().delete('/brand/' + id);
  },

  getRecommendedSourceProfile(id) {
    return api().get('/brand/' + id + '/recommended-source-profile')
      .then(resp => resp ? new SourceProfile(resp) : null);
  },

  getActivityLogs({ id, page, limit }) {
    const data = {};
    if (page){
      data['page'] = page;
    }
    if (limit){
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data).toString();

    return api().get('/brand/' + id + '/activity-logs?' + query)
      .then(resp => resp.map(i => new RuleActivityLog(i)));
  },
};
